export default "__VITE_ASSET__C2xzcu_D__"